"use client";

import Link from "next/link";
import SideMenuMobile from "./SideMenuMobile";
import NavButtons from "./NavButtons";

const MobileNavbar = () => {
  return (
    <nav className="flex w-full items-center justify-between md:hidden">
      <div className="flex items-center justify-start gap-x-3">
        <SideMenuMobile />
        <Link href="/" prefetch={true}>
          <img
            src="/images/Logo.png"
            alt="Company logo"
            className="h-6 w-auto max-w-[120px] cursor-pointer"
          />
        </Link>
      </div>
      <NavButtons isMobileScreen />
    </nav>
  );
};

export default MobileNavbar;
